/**
 * 详情页面的详情信息（展示效果参考财务管理/资金管理/资金详情里的非表格区域部分）
 * props: [title]      [string]                   标题 [可选]
 *        content      [F.MoneyDetial.RowData]    内容(格式如/typings/index.d.ts 的F.MoneyDetial.RowData)
 *        [gutter]     [number]                   可选属性，与antd的Row组件的gutter一致，默认是10
 *        [symbol]     [string]                   可选属性，单元列（key,value列）之间的分割符号，默认为中文的：
 *        [className]  [string]                   可选属性，DetailInfo类名
 * @augments 依据content数组里的每一项为一行，每一项的每一个对象为一单元列（key,value列）来展示
 * 不同行的key列垂直对齐；
 * key列和value列有默认占比值，分别为（24/N*3/8=9/N, 24/N*5/8=15/N)
 * 如展示的行中含有单元列数量最多为N，其余行展示的单元列数量K不足N时，该行最后一个单元列的value列占比为该行剩余宽度(24-24/N*K+24/N*5/8)；
 */
import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { Root } from './style';
import { judgeArr } from '@/shared/functions';
class DetailInfo extends Component {
    constructor() {
        super(...arguments);
        this.getMaxColsLen = (d) => {
            let _maxLen = 0;
            for (const elem of d.values()) {
                const elemLen = elem.length;
                if (_maxLen < elemLen) {
                    _maxLen = elemLen;
                }
            }
            return _maxLen;
        };
        this.getRow = (d) => {
            if (!judgeArr(d)) {
                console.warn('DetailInfo数据不合法');
                return null;
            }
            const _maxLen = this.getMaxColsLen(d);
            const rows = d.map((dLine, i) => {
                return (<Row className="row" key={i} gutter={this.props.gutter}>
            {this.getCol(dLine, _maxLen)}
        </Row>);
            });
            return rows;
        };
        this.getCol = (d, len) => {
            if (!judgeArr(d)) {
                console.warn('DetailInfo数据不合法');
                return null;
            }
            const cLen = d.length;
            const _keySpan = Math.floor(9 / len);
            const _valueSpan = Math.floor(15 / len);
            const _lastVSpan = Math.floor(24 - 24 / len * cLen + 15 / len);
            const cols = d.map((rLine, i) => {
                return (<React.Fragment key={i}>
            <Col className="col__key" span={_keySpan} dangerouslySetInnerHTML={{ __html: `${rLine.key}${this.props.symbol}` }}/>
            <Col className="col__value" span={i === cLen - 1 ? _lastVSpan : _valueSpan}>
              {rLine.value}
            </Col>
        </React.Fragment>);
            });
            return cols;
        };
    }
    render() {
        const { title, content, className } = this.props;
        return (<Root className={className}>
          {title && <div className="title">{title}</div>}
          <div className="content">{this.getRow(content)}</div>
      </Root>);
    }
}
DetailInfo.defaultProps = {
    gutter: 10,
    symbol: '：',
};
export default DetailInfo;
